import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { X, AlertCircle } from 'lucide-react';

const STORAGE_KEY = 'smartfacture_reform_banner_dismissed';
const DAYS_TO_HIDE = 30;

// Routes where the banner should NOT appear (redundant with page content)
const HIDDEN_ON_ROUTES = ['/', '/pricing', '/simulateur', '/demo'];

const ReformBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Check if banner was dismissed
    const dismissedAt = localStorage.getItem(STORAGE_KEY);
    
    if (dismissedAt) {
      const dismissedDate = new Date(parseInt(dismissedAt));
      const now = new Date();
      const daysSinceDismissed = (now - dismissedDate) / (1000 * 60 * 60 * 24);
      
      // Show again after 30 days
      if (daysSinceDismissed >= DAYS_TO_HIDE) {
        localStorage.removeItem(STORAGE_KEY);
        setIsVisible(true);
      }
    } else {
      // Never dismissed, show banner
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    setIsVisible(false);
  };

  if (!isVisible) return null;
  if (HIDDEN_ON_ROUTES.includes(location.pathname)) return null;

  return (
    <div className="bg-gradient-to-r from-emerald-600 to-emerald-700 text-white py-2.5 px-4 relative z-[60]">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 text-sm">
        <AlertCircle className="h-4 w-4 shrink-0 opacity-80" />
        <p className="text-center">
          <span className="font-medium">Facturation électronique obligatoire en 2026.</span>
          <span className="hidden sm:inline"> Préparez votre entreprise dès maintenant avec SmartFacture AI.</span>
        </p>
        <Link 
          to="/register"
          className="shrink-0 px-3 py-1 bg-white text-emerald-700 text-xs font-semibold rounded hover:bg-emerald-50 transition-colors"
        >
          Essayer gratuitement
        </Link>
        <button 
          onClick={handleDismiss}
          className="shrink-0 p-1 hover:bg-white/10 rounded transition-colors ml-2"
          aria-label="Fermer"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default ReformBanner;
